import React, { useEffect, useRef, useState } from "react";
import { Map, AdvancedMarker, Marker, useMap } from '@vis.gl/react-google-maps'
import moment from "moment/moment";
import { Card } from "@mui/material";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import convertUtils from 'convert-units';
import Polyline from "./Polyline";
import crudsService from "services/cruds-service";
import MapToolbar from "./MapToolbar";
import { useMediaQuery } from "react-responsive";
import { toast } from "react-toastify";
import { generateColors, convertIntoNumber, findStopPoints, findPausePoints, wayPointTrack } from "utils/helper";
import { LastLocationCard, InfoCard, RouteInfoCard } from "./helperComponent";
const mapContainerStyle = {
    width: "100%",
    height: "500px",
};
let pulseStyle = {
    position: "relative",
    width: "50px",
    height: "50px",
    backgroundColor: "rgba(0, 150, 255, 0.5)",
    borderRadius: "50%",
    animation: "pulse 1.5s infinite",
    top: '-45px',
    left: '-5px',
};
const iconContainerStyle = {
    width: '35px',
    height: '35px',
}

const AssetTrackerMap = ({ latitude, longitude, mapIcon, gpsStatus, heading, ignoreHeading, icons, routeData, closeHighlightRoute, activeAlerts = [], geofence, paramValue }) => {

    const center = {
        lat: Number(latitude),
        lng: Number(longitude),
    };

    const [polylinePaths, setPolylinePaths] = useState([]);
    const [selectedMarker, setSelectedMarker] = useState(null);
    const [vehiclePosition, setVehiclePosition] = useState(center);
    const [iconColor, setIconColor] = useState('green')
    const map = useMap();
    const vehiclePos = useRef(null)
    const [showRoutesPolygon, setShowRoutesPolygon] = useState(localStorage.getItem('showRoutePolygon') == 'true' ?? false)
    const [shouldShowAddress, setShouldShowAddress] = useState(null)
    const [shouldShowSimpleRoute, setShouldShowSimpleRoute] = useState(localStorage.getItem('shouldShowSimpleRoute') == 'true' ??false)
    const isTabletOrMobile = useMediaQuery({ query: "(max-width: 1224px)" });

    const routeColors = generateColors(routeData.length);

    async function fetchSnapToRoads(route_id) {
        try {
            let resp = await crudsService.getSnapRoads(route_id)
            if (resp.success) {
                return resp.data
            } else {
                return []
            }
        } catch (error) {
            console.error('fetchSnapToRoads error', error)
            return []
        }
    }

    async function processRoutes(value) {
        const allPolylines = await Promise.all(routeData.map(async (route, index) => {
            let waypoints = [];

            // Case 1: Live trip – use raw tracking points directly
            if (['Moving', 'Idle', 'Delayed'].includes(gpsStatus) && !route?.end_latitude) {
                waypoints = route?.RouteTrackingPoints?.map(point => ({
                    lat: convertIntoNumber(point.latitude),
                    lng: convertIntoNumber(point.longitude)
                })) || [];
            } else if ([false].includes(value) ?? !shouldShowSimpleRoute) {
                waypoints = route?.RouteTrackingPoints?.map(point => ({
                    lat: convertIntoNumber(point.latitude),
                    lng: convertIntoNumber(point.longitude)
                })) || [];
            }
            // Case 2: Trip ended – try snapped road points
            else if (route?.RouteTrackingPoints?.length >= 2) {
                const snap_to_roads = await fetchSnapToRoads(route.route_id);

                if (Array.isArray(snap_to_roads) && snap_to_roads.length > 0) {
                    waypoints = snap_to_roads.map(point => ({
                        lat: convertIntoNumber(point.location.latitude),
                        lng: convertIntoNumber(point.location.longitude)
                    }));
                } else {
                    // Fallback to raw tracking points
                    waypoints = route.RouteTrackingPoints.map(point => ({
                        lat: convertIntoNumber(point.latitude),
                        lng: convertIntoNumber(point.longitude)
                    }));
                }
            }

            return waypoints;

        }));
        setPolylinePaths(allPolylines);

        const trackingPoints = routeData[0]?.RouteTrackingPoints;
        if (trackingPoints && trackingPoints.length >= 2 && gpsStatus == 'Moving' && !routeData[0]?.end_latitude) {
            const secondLast = trackingPoints[trackingPoints.length - 2];
            const last = trackingPoints[trackingPoints.length - 1];

            const start = { lat: Number(secondLast.latitude), lng: Number(secondLast.longitude) };
            const end = { lat: Number(last.latitude), lng: Number(last.longitude) };

            animateMarker(start, end);
        }
    }

    const animateMarker = (start, end, duration = 3000) => {
        let startTime = null;

        const animate = (timestamp) => {
            if (!startTime) startTime = timestamp;
            const progress = (timestamp - startTime) / duration;

            if (progress < 1) {
                const lat = start.lat + (end.lat - start.lat) * progress;
                const lng = start.lng + (end.lng - start.lng) * progress;
                setVehiclePosition({ lat, lng });
                requestAnimationFrame(animate);
            } else {
                setVehiclePosition(end);
            }
        };

        requestAnimationFrame(animate);
    };

    function handleMarkerClick(type, position, info = null) {
        setSelectedMarker({ type, position, info })
        map?.setCenter({ lat: parseFloat(position.latitude), lng: parseFloat(position.longitude) });
    }
    function removeMarkerClick() {
        setSelectedMarker(null)
    }

    function showDevice() {
        map?.setCenter({ lat: parseFloat(latitude), lng: parseFloat(longitude) });
    }

    function showPolygon() {
        setShowRoutesPolygon(!showRoutesPolygon)
        localStorage.setItem('showRoutePolygon', !showRoutesPolygon)
    }

    function RenderIcon() {
        if (ignoreHeading || ['Parked', 'Idle'].includes(gpsStatus)) {
            return (<div style={{ ...iconContainerStyle, color: iconColor }}>
                <div class="icon-wrapper">
                    <i class={mapIcon}></i>
                </div>
                {
                    ['Idle', 'Moving'].includes(gpsStatus) ?
                        <div style={pulseStyle}></div> : ''
                }
            </div>)
        }
        if (heading < 45 || heading > 315) {
            return (<div style={{ ...iconContainerStyle, color: iconColor }}>
                <div class="icon-wrapper">
                    <i class={mapIcon}></i>
                </div>
                <div style={{ fontSize: '24px', position: 'relative', right: '-11px', top: '-68px' }}>
                    <i class="fa-solid fa-arrow-up"></i>
                </div>
                {
                    ['Idle', 'Moving'].includes(gpsStatus) ?
                        <div style={{ ...pulseStyle, top: '-72px' }}></div> : ''
                }
            </div>)
        }
        if (heading > 135 && heading < 225) {
            return (<div style={{ ...iconContainerStyle, color: iconColor }}>
                <div class="icon-wrapper">
                    <i class={mapIcon}></i>
                </div>
                <div style={{ fontSize: '24px', position: 'relative', right: '-11px', top: '2px' }}>
                    <i class="fa-solid fa-arrow-down"></i>
                </div>
                {
                    ['Idle', 'Moving'].includes(gpsStatus) ?
                        <div style={{ ...pulseStyle, top: '-72px' }}></div> : ''
                }
            </div>)
        }
        const flip = heading >= 225 && heading <= 315 ? 'scaleX(-1)' : 'scaleX(1)';
        return (<div style={{ ...iconContainerStyle, color: iconColor }}>
            <div class="icon-wrapper">
                <i class={mapIcon} style={{ transform: `${flip}` }}></i>
            </div>
            {
                ['Idle', 'Moving'].includes(gpsStatus) ?
                    <div style={pulseStyle}></div> : ''
            }
        </div>)
        // return <i class={mapIcon} style={{ transform: `rotate(${heading}deg) ${flip}` }}></i>
        // return <i class={mapIcon} style={`transform: rotate(${heading}deg) ${flip};`}></i>
    }

    function funShouldShowSimpleRoute(value) {
        setShouldShowSimpleRoute(value)
        localStorage.setItem('shouldShowSimpleRoute', value)
        if (value) {
            processRoutes(value)
        } else {
            setPolylinePaths(routeData.map(route => route.RouteTrackingPoints.map(point => ({
                lat: convertIntoNumber(point.latitude),
                lng: convertIntoNumber(point.longitude)
            }))))
        }
    }

    async function regenerateRoutes() {
        if(!routeData?.length){
            toast.info('There is no route running!')
            return
        }
        if (!routeData[0]?.end_longitude) {
            toast.info('Route already running')
            return
        }
        if(confirm('Are you sure you want to regenerate routes?')) {
            const resp = await crudsService.regenerateRoutes(routeData[0].route_id)
            if (resp.success) {
                toast.success('Routes regenerated successfully')
                let waypoints = resp.data?.map(point => ({
                    lat: convertIntoNumber(point.location.latitude),
                    lng: convertIntoNumber(point.location.longitude)
                })) || [];
                setPolylinePaths([waypoints]);
            } else {
                toast.error('Failed to regenerate routes')
            }
        }
    }

    useEffect(() => {
        if (routeData.length > 0) {
            processRoutes();
        } else {
            setPolylinePaths([])
        }
    }, [routeData]);

    useEffect(() => {
        if (!map) return

        if (gpsStatus === "Moving") {
            map.setCenter({ lat: Number(latitude), lng: Number(longitude) });
        } else {
            map.setCenter({ lat: Number(latitude), lng: Number(longitude) });
        }
        if (vehiclePos.current) {
            vehiclePos.current.position = { lat: Number(latitude), lng: Number(longitude) }
        }
        if(paramValue['reverse_geocoded_address']){
            setShouldShowAddress(paramValue['reverse_geocoded_address']?.formatted_address)
        } else {
            setShouldShowAddress(null)
        }

    }, [latitude, longitude, gpsStatus, map, geofence]);

    useEffect(() => {
        let color = 'green'
        if (activeAlerts.length > 0) {
            // color = 'red'
            color = activeAlerts[0]?.AlertType?.BadgeDetail?.font_color_hex ?? 'red'
        }
        setIconColor(color)
    }, [mapIcon, activeAlerts])

    return (
        <Map
            style={mapContainerStyle}
            defaultCenter={center}
            defaultZoom={15}
            gestureHandling={'greedy'}
            // disableDefaultUI={true}
            mapId={'d089c1a7f8831a36'}
        > 
            {/* Toolbar */}
            <MapToolbar showDevice={showDevice} isRoutesPolygonShow={showRoutesPolygon} showPolygon={showPolygon} shouldShowSimpleRoute={shouldShowSimpleRoute} funShouldShowSimpleRoute={funShouldShowSimpleRoute} regenerateRoutes={regenerateRoutes} />
            {/* Info Card */}
            {selectedMarker && <InfoCard marker={selectedMarker} removeMarkerClick={removeMarkerClick} />}

            { shouldShowAddress && <LastLocationCard address={shouldShowAddress} isTabletOrMobile={isTabletOrMobile} /> }

            {
                routeData.length ? (routeData[0]?.selected ?
                    <RouteInfoCard route={routeData[0]} closeHighlightRoute={closeHighlightRoute} />
                    : '') : ''
            }
            {showRoutesPolygon && polylinePaths.map((path, index) => (
                <Polyline
                    key={index}
                    encodedPath={path}
                    // options={{
                    strokeColor={routeColors[index]}
                    strokeOpacity={0.8}
                    strokeWeight={3}
                    strokeDasharray={[10, 10]}
                // }} 
                />
            ))}
            {showRoutesPolygon && routeData.map((route, index) => {
                const trackingPoints = route?.RouteTrackingPoints || [];
                const end_latitude = route?.end_latitude || null;
                const startPoint = trackingPoints[0]; // First in time order
                const endPoint = trackingPoints[trackingPoints.length - 1]; // Last in time order
                const stopPoints = findStopPoints(trackingPoints); // Find stops
                const pausePoints = findPausePoints(trackingPoints); // Find stops
                const wayPoints = wayPointTrack(trackingPoints); // Find stops
                return (
                    <React.Fragment key={route.route_id}>


                        {/* Start Marker */}
                        {startPoint && (
                            <Marker
                                position={{
                                    lat: convertIntoNumber(startPoint.latitude),
                                    lng: convertIntoNumber(startPoint.longitude)
                                }}
                                icon={{
                                    path: google.maps.SymbolPath.CIRCLE,
                                    fillColor: '#28a745',
                                    fillOpacity: 0.9,
                                    strokeWeight: 2,
                                    strokeColor: '#ffffff',
                                    scale: 10
                                }}
                                title="Start Point"
                                animation={google.maps.Animation.DROP}
                                onClick={() => handleMarkerClick('start', startPoint)}
                            />
                        )}

                        {/* End Marker */}
                        {(endPoint && end_latitude) && (
                            <Marker
                                position={{
                                    lat: convertIntoNumber(endPoint.latitude),
                                    lng: convertIntoNumber(endPoint.longitude)
                                }}
                                icon={{
                                    path: google.maps.SymbolPath.CIRCLE,
                                    fillColor: '#dc3545',
                                    fillOpacity: 0.9,
                                    strokeWeight: 2,
                                    strokeColor: '#ffffff',
                                    scale: 10
                                }}
                                title="End Point"
                                animation={google.maps.Animation.DROP}
                                onClick={() => handleMarkerClick('end', endPoint)}
                            />
                        )}

                        {/* Stop Markers (Stops longer than 10 min) */}
                        {stopPoints.map((point, i) => (
                            <Marker
                                key={`stop-${i}`}
                                position={{
                                    lat: convertIntoNumber(point.device.latitude),
                                    lng: convertIntoNumber(point.device.longitude)
                                }}
                                icon={{
                                    url: "https://maps.gstatic.com/mapfiles/ms2/micons/parkinglot.png", // Yellow Stop Icon
                                    scaledSize: new window.google.maps.Size(25, 25)
                                }}
                                title={`Stop Point (${point.diff} min)`}
                                onClick={() => handleMarkerClick('stop', point.device, `Stopped for ${point.diff} min`)}
                            />
                        ))}
                        {/* Stop Markers (Stops longer than 10 min) */}
                        {pausePoints.map((point, i) => (
                            <AdvancedMarker key={`pause-${i}`} position={{
                                lat: convertIntoNumber(point.device.latitude),
                                lng: convertIntoNumber(point.device.longitude)
                            }} onClick={() => handleMarkerClick('pause', point.device, `Paused for ${point.diff} min`)} >
                                <div>
                                    <i className={icons.class_name} style={{ fontSize: '24px', color: 'orange' }} />
                                </div>
                            </AdvancedMarker>
                        ))}
                        {/* Way Point track */}
                        {wayPoints.map((point, i) => (
                            <Marker
                                key={`way-${i}`}
                                position={{
                                    lat: convertIntoNumber(point.device.latitude),
                                    lng: convertIntoNumber(point.device.longitude)
                                }}
                                icon={{
                                    path: google.maps.SymbolPath.CIRCLE,
                                    fillColor: '#3388ff',
                                    fillOpacity: 0.7,
                                    strokeWeight: 1,
                                    strokeColor: '#ffffff',
                                    scale: 5
                                }}
                                title={`Waypoint (${point.device.point_id}, ${point.sequence})`}
                                onClick={() => handleMarkerClick('waypoint', point.device, `Waypoint (${point.device.point_id}, ${point.sequence})`)}
                            />
                        ))}
                    </React.Fragment>
                );
            })}
            <AdvancedMarker ref={vehiclePos} position={vehiclePosition} zIndex={100} >
                <RenderIcon />
            </AdvancedMarker>
        </Map>
    );
};

export default AssetTrackerMap;